<template>
  <v-dialog persistent v-model="visible" scrollable max-width="650px">
    <v-card>
      <v-card-title>{{ $t("common.add") }}</v-card-title>
      <v-card-text>
        <v-form ref="RepairtimeTreeCustomWindowForm">
          <v-text-field
            outlined
            :value="repairtimeCustom.name_ru"
            v-model="repairtimeCustom.name_ru"
            :label="$t('viewRepairtimeeTree.name_ru')"
          >
          </v-text-field>
          <v-text-field
            v-if="!repairtimeCustom.included"
            outlined
            :value="repairtimeCustom.time"
            v-model="repairtimeCustom.time"
            :label="$t('viewRepairtimeeTree.time_with_def')"
          >
          </v-text-field>
          <v-text-field
            v-if="isFixedPrice && !repairtimeCustom.included"
            outlined
            :value="repairtimeCustom.fixed_price"
            v-model="repairtimeCustom.fixed_price"
            :label="$t('viewRepairtimeeTree.fixed_price')"
          >
          </v-text-field>
          <v-checkbox
            :disabled="repairtimeCustom.included"
            v-model="isFixedPrice"
            :label="$t('viewRepairtimeeTree.fixed_price')"
            class="d-inline"
          />
          <v-checkbox
            v-model="repairtimeCustom.included"
            :label="$t('viewRepairtimeeTree.including')"
            class="d-inline"
          />
          <v-divider></v-divider>
          <v-row justify="start">
            <v-spacer></v-spacer>
            <v-btn
              :loading="isSaving"
              class="mr-2 mt-4 white--text"
              color="red"
              elevation="0"
              @click="close"
            >
              {{ $t("common.cancel") }}
            </v-btn>
            <v-btn
              :loading="isSaving"
              class="mr-2 mt-4 white--text"
              color="primary"
              elevation="0"
              @click="save"
            >
              {{ $t("common.save") }}
            </v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RepairtimeTreeCustomWindow",
  props: {
    item: {
      type: Object,
    },
    parentItem: {
      type: Object,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isSaving: false,
    isFixedPrice: false,
    repairtimeCustom: {
      id: null,
      name_ru: null,
      time: null,
      included: null,
      parent: null,
      fixed_price: null,
    },
  }),
  watch: {
    isFixedPrice(to) {
      if (!to) this.repairtimeCustom.fixed_price = null;
    },
    parentItem() {
      this.isFixedPrice = null;
      this.repairtimeCustom.parent = this.parentItem.idx;
    },
    item(to) {
      if(this.item) {
        this.repairtimeCustom = {...this.item};
      }
      if(to && to.overridden && to.overridden.fixed_price){
        this.repairtimeCustom.fixed_price = to.overridden.fixed_price;
        this.isFixedPrice = true;
      }
    },
    visible(to){
      if(this.item) {
        this.repairtimeCustom = {...this.item};
      }
      if(!to) {
        this.cleanRepairtimeCustom()
      }
    }
  },
  methods: {
    cleanRepairtimeCustom(){
      let keys = Object.keys(this.repairtimeCustom);
      keys.forEach((key)=>{
        this.repairtimeCustom[key] = null;
      })
    },
    save() {
      this.isSaving = true;
      if(this.repairtimeCustom.id){
        this.$store.dispatch('repairtimes/repairtimeCustomUpdate', this.repairtimeCustom).then((res)=>{
          this.isSaving = false;
          if(res) this.close();
        })
      } else {
        this.$store.dispatch('repairtimes/repairtimeCustomStore', this.repairtimeCustom).then((res)=>{
          this.isSaving = false;
          if(res) this.close();
        })
      }
    },
    close() {
      //this.cleanRepairtimeCustom();
      this.$emit("hide");
    },
  },
};
</script>

<style scoped></style>
